import React from 'react';
import { Calendar, TrendingUp, Award, Building2, FileText } from 'lucide-react';
import { useTranslations } from '../hooks/useTranslations';
export function Requirements() {
  const {
    t
  } = useTranslations();
  return <section id="requirements" className="py-10 bg-[#f0faf4]" data-id="element-295">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-296">
        <div className="text-center mb-8" data-id="element-297">
          <p className="text-xs font-bold tracking-widest text-gray-500 uppercase mb-2" data-id="element-298">
            {t('requirements.eyebrow')}
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-299">
            {t('requirements.title')}
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 mb-8" data-id="element-300">
          <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 text-center" data-id="element-301">
            <div className="w-12 h-12 rounded-lg bg-purple-500 flex items-center justify-center mx-auto mb-3" data-id="element-302">
              <Calendar className="w-6 h-6 text-white" data-id="element-303" />
            </div>
            <h3 className="text-lg font-bold text-gray-900" data-id="element-304">
              {t('requirements.req1.title')}
            </h3>
            <p className="text-xs text-gray-500 mt-1" data-id="element-305">
              {t('requirements.req1.desc')}
            </p>
          </div>

          <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 text-center" data-id="element-306">
            <div className="w-12 h-12 rounded-lg bg-blue-500 flex items-center justify-center mx-auto mb-3" data-id="element-307">
              <TrendingUp className="w-6 h-6 text-white" data-id="element-308" />
            </div>
            <h3 className="text-lg font-bold text-gray-900" data-id="element-309">
              {t('requirements.req2.title')}
            </h3>
            <p className="text-xs text-gray-500 mt-1" data-id="element-310">
              {t('requirements.req2.desc')}
            </p>
          </div>

          <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 text-center" data-id="element-311">
            <div className="w-12 h-12 rounded-lg bg-orange-500 flex items-center justify-center mx-auto mb-3" data-id="element-312">
              <Award className="w-6 h-6 text-white" data-id="element-313" />
            </div>
            <h3 className="text-lg font-bold text-gray-900" data-id="element-314">
              {t('requirements.req3.title')}
            </h3>
            <p className="text-xs text-gray-500 mt-1" data-id="element-315">
              {t('requirements.req3.desc')}
            </p>
          </div>

          <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 text-center" data-id="element-316">
            <div className="w-12 h-12 rounded-lg bg-emerald-500 flex items-center justify-center mx-auto mb-3" data-id="element-317">
              <Building2 className="w-6 h-6 text-white" data-id="element-318" />
            </div>
            <h3 className="text-lg font-bold text-gray-900" data-id="element-319">
              {t('requirements.req4.title')}
            </h3>
            <p className="text-xs text-gray-500 mt-1" data-id="element-320">
              {t('requirements.req4.desc')}
            </p>
          </div>

          <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 text-center col-span-2 sm:col-span-1" data-id="element-321">
            <div className="w-12 h-12 rounded-lg bg-red-500 flex items-center justify-center mx-auto mb-3" data-id="element-322">
              <FileText className="w-6 h-6 text-white" data-id="element-323" />
            </div>
            <h3 className="text-lg font-bold text-gray-900" data-id="element-324">
              {t('requirements.req5.title')}
            </h3>
            <p className="text-xs text-gray-500 mt-1" data-id="element-325">
              {t('requirements.req5.desc')}
            </p>
          </div>
        </div>

        <div className="text-center" data-id="element-326">
          <p className="text-xs text-gray-500" data-id="element-327">{t('requirements.subtitle')}</p>
        </div>
      </div>
    </section>;
}